/* eslint-disable @typescript-eslint/naming-convention */
import {
  TaggedEnumUnion,
  buildTaggedEnumType,
  describeTaggedEnumType,
} from '@suntex.core/types';

import { buildStaticContext } from '../utils';

const $ = '_ModuleInfo';

enum _ModuleInfo {
  ss_1_1 = 1,
  ss_1_2 = 2,
  ss_1_3 = 3,
  ss_2_1 = 4,
  ss_2_2 = 5,
  ss_2_3 = 6,
  ss_3_1 = 7,
  ss_3_2 = 8,
  ss_3_3 = 9,
  ss_4_1 = 10,
  ss_4_2 = 11,
  ss_4_3 = 12,
  ss_5_1 = 13,
  ss_5_2 = 14,
  ss_5_3 = 15,
  ss_6_1 = 16,
  ss_6_2 = 17,
  ss_6_3 = 18,
  ss_7_1 = 19,
  ss_7_2 = 20,
  ss_7_3 = 21,
  ss_8_1 = 22,
  ss_8_2 = 23,
  ss_8_3 = 24,
  jtf_num_add = 25,
  jtf_num_sub = 26,
  jtf_num_mul = 27,
  jtf_num_div = 28,
  jtf_frc_add = 29,
  jtf_frc_sub = 30,
  jtf_frc_mul = 31,
  jtf_frc_div = 32,
  jtf_dec_add = 33,
  jtf_dec_sub = 34,
  jtf_dec_mul = 35,
  jtf_dec_div = 36,
  jtf_int_add = 37,
  jtf_int_sub = 38,
  jtf_int_mul = 39,
  jtf_int_div = 40,
  jtf_100_add = 41,
  jtf_100_sub = 42,
  jtf_100_mul = 43,
  jtf_100_div = 44,
  gym_num_add = 45,
  gym_num_sub = 46,
  gym_num_mul = 47,
  gym_num_div = 48,
  gym_frc_add = 49,
  gym_frc_sub = 50,
  gym_frc_mul = 51,
  gym_frc_div = 52,
  gym_dec_add = 53,
  gym_dec_sub = 54,
  gym_dec_mul = 55,
  gym_dec_div = 56,
  gym_int_add = 57,
  gym_int_sub = 58,
  gym_int_mul = 59,
  gym_int_div = 60,
  wdyk_1 = 61,
  wdyk_2 = 62,
  wdyk_3 = 63,
  ks_3_1 = 64,
  ks_3_2 = 65,
  ks_3_3 = 66,
  ks_3_4 = 67,
  ks_3_5 = 68,
  ks_3_6 = 69,
  ks_3_7 = 70,
  ks_3_8 = 71,
  ks_3_9 = 72,
  ks_5_1 = 73,
  ks_5_2 = 74,
  ks_5_3 = 75,
  ks_5_4 = 76,
  ks_5_5 = 77,
  ks_5_6 = 78,
  ks_5_7 = 79,
  ks_5_8 = 80,
  ks_5_9 = 81,
  ks_7_1 = 82,
  ks_7_2 = 83,
  ks_7_3 = 84,
  ks_7_4 = 85,
  ks_7_5 = 86,
  ks_7_6 = 87,
  ks_7_7 = 88,
  ks_7_8 = 89,
  ks_7_9 = 90,
  ten_wheels = 91,
  first_in_tens_add = 92,
  first_in_tens_sub = 93,
  mol = 94,
  shape_shuffle = 95,
  deep_seaquence = 96,
  grand_slam_add_sub = 97,
  first_to_twenty_add = 98,
  first_to_twenty_sub = 99,
  speed_shuffle = 100,
  touchdown_100_add = 101,
  touchdown_100_sub = 102,
  factor_wheels = 103,
  grand_slam_mul_div = 104,
  skip_game = 105,
  decimals_mol = 106,
  xyz_shuffle = 107,
  _24_wheels = 108,
  monus_path = 109,
  the_hex_factor = 110,
  fractions_mol = 111,
  pundis_puzzle = 112,
  rps = 113,
  fraction_wheels = 114,
  pattern_puzzle = 115,
  monujis_path = 116,
  pattern_power = 117,
  grand_slam_integers = 118,
  xtreme_algebra = 119,
  algebra_mol = 120,
  rps_master = 121,
  into_the_vortex = 122,
  equal_length = 123,
  time_more_or_less = 124,
  equal_time = 125,
  passing_time = 126,
  equal_pay = 127,
  making_change = 128,
  equal_weight = 129,
  area_perimeter_square = 130,
  area_perimeter_circle = 131,
  area_perimeter_rectangle = 132,
  area_perimeter_triangle = 133,
  k2_rps = 134,
  _3_to_9_add = 135,
  _3_to_9_sub = 136,
  k2_mol = 137,
  k2_skip_game = 138,
  k2_pundis_puzzle = 139,
  see_3 = 140,
  k2_triplets = 141,
  jtf_k2_add = 142,
  jtf_k2_sub = 143,
  jtf_k2_mul = 144,
  jtf_k2_div = 145,
  gym_k2_add = 146,
  gym_k2_sub = 147,
  gym_k2_mul = 148,
  gym_k2_div = 149,
  ks_1_1 = 150,
  ks_1_2 = 151,
  ks_1_3 = 152,
  ks_1_4 = 153,
  grand_slam_frc_add_sub = 154,
  grand_slam_frc_mul_div = 155,
  grand_slam_frc_all = 156,
  grand_slam_dec_add_sub = 157,
  grand_slam_dec_mul_div = 158,
  grand_slam_dec_all = 159,
  _3_moves_to_0 = 160,
  _3_moves_to_0_quantum = 161,
  ks_2_1 = 162,
  ks_2_2 = 163,
  ks_2_3 = 164,
  ks_2_4 = 165,
  vif_add = 166,
  vif_sub = 167,
  vif_mul = 168,
  vif_div = 169,
  vif_add_rules = 170,
  vif_sub_rules = 171,
  vif_mul_rules = 172,
  vif_div_rules = 173,
  vif_add_redo = 174,
  vif_sub_redo = 175,
  vif_mul_redo = 176,
  vif_div_redo = 177,
  vif_add_rules_dd = 178,
  vif_sub_rules_dd = 179,
  vif_mul_rules_dd = 180,
  vif_div_rules_dd = 181,
  estimation = 182,
  jtf_100_frc_add = 183,
  jtf_100_frc_sub = 184,
  jtf_100_frc_mul = 185,
  jtf_100_frc_div = 186,
  jtf_100_dec_add = 187,
  jtf_100_dec_sub = 188,
  jtf_100_dec_mul = 189,
  jtf_100_dec_div = 190,
  jtf_100_int_add = 191,
  jtf_100_int_sub = 192,
  jtf_100_int_mul = 193,
  jtf_100_int_div = 194,
  estimation_dec = 195,
  equal_pay_india = 196,
  k2_undo = 197,
  pk_three_at_a_time = 198,
  k2_four_at_a_time = 199,
  equivalents = 200,
  rps_newb_ct = 201,
  rps_ct = 202,
  rps_master_ct = 203,
  k2_how_many = 204,
  pundis_puzzle_ct = 205,
  misfits_newb = 206,
  misfits = 207,
  misfits_master = 208,
  zero_sum = 209,
  k2_five_at_a_time = 210,
  misfits_num = 211,
  misfits_frc = 212,
  misfits_dec = 213,
  making_change_india = 214,
  grand_slam_alg = 215,
  k2_misfits = 216,
  k2_misfits_num = 217,
  misfits_37 = 218,
  misfits_37_num = 219,
  ks_4_1 = 220,
  ks_4_2 = 221,
  ks_4_3 = 222,
  ks_4_4 = 223,
  ks_4_5 = 224,
  ks_4_6 = 225,
  ks_4_7 = 226,
  ks_4_8 = 227,
  ks_4_9 = 228,
  ks_6_1 = 229,
  ks_6_2 = 230,
  ks_6_3 = 231,
  ks_6_4 = 232,
  ks_6_5 = 233,
  ks_6_6 = 234,
  ks_6_7 = 235,
  ks_6_8 = 236,
  ks_6_9 = 237,
  pk_how_many = 238,
  k2_before_and_after = 239,
  pk_before_and_after = 240,
  pk_mol = 241,
  pk_missing_icons = 242,
  k2_missing_icons_ct = 243,
  k2_pundis_puzzle_ct = 244,
  k2_rps_ct = 245,
  k2_misfits_num_ct = 246,
  zero_sum_newb = 247,
  k2_monus_path_ct = 248,
  undo_fractions = 249,
  factor_wheels_ct = 250,
  k2_jennies_jewels = 251,
  jennies_jewels = 252,
  k2_what_belongs_ct = 253,
  link_n_lock_as = 254,
  link_n_lock_md = 255,
  link_n_lock_frc = 256,
  wdyk2 = 257,
  link_n_lock_mosaic = 258,
  link_n_lock_jewels = 259,
  gems_to_zero = 260,
  jeweled_tiles = 261,
  equivalent_fraction_tiles = 262,
  algebra_tiles = 263,
  decimal_tiles = 264,
  vif_tiles = 265,
  exponent_tiles = 266,
  integer_tiles = 267,
  order_of_operations_tiles = 268,
  fraction_tiles = 269,
  early_algebra_tiles = 270,
  pk_memory_tiles = 271,
  elementary_algebra_tiles = 272,
  geometry_tiles = 273,
  money_tiles = 274,
  contest_skillsets = 275,
  quantum_algebra = 276,
  ks_8_1 = 277,
  ks_8_2 = 278,
  ks_8_3 = 279,
  ks_8_4 = 280,
  ks_8_5 = 281,
  ks_8_6 = 282,
  ks_8_7 = 283,
  ks_8_8 = 284,
  ks_8_9 = 285,
  dii_fractions = 286,
  abc = 287,
  letter_memory = 288,
  matching_letters = 289,
  alphabet = 290,
  high_fq_words = 291,
  rhyme_time = 292,
  misfits_spelling = 293,
  missing_letters = 294,
  verb_tenses = 295,
  building_sentences = 296,
  consonant_blends = 297,
  math_words = 298,
  cb_sounds = 299,
  phonemes_alpha = 300,
  phonemes_pi = 301,
  sound_of_letters = 302,
  change_one_letter = 303,
  word_wheels = 304,
  finding_words_4x4 = 305,
  ten_wheels_elite = 306,
}

export const ModuleInfo = buildTaggedEnumType($, _ModuleInfo);
// A union type this long is not very useful
export type ModuleInfo = TaggedEnumUnion<typeof ModuleInfo>;
//export type ModuleInfo = TaggedEnum<typeof $, number>;

export const $ModuleInfo = buildStaticContext(
  describeTaggedEnumType($, ModuleInfo),
);
